import { type CollectionStatusEnum } from "@kanpla/api-contract";
import { clsx } from "clsx";

import { collectionStatusCardBg } from "~/components/collect/collection-status-styles";

import { Avatar } from "../avatar";

type CustomerItemArgs = {
  name: string;
  orderStatus: CollectionStatusEnum;
  className?: string;
  onClick?: () => void;
};

export const CustomerItem = ({
  name,
  orderStatus,
  className,
  onClick
}: CustomerItemArgs) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "flex items-center justify-between gap-4 rounded-md p-3",
        collectionStatusCardBg({ status: orderStatus }),
        className
      )}
    >
      <p className="line-clamp-2 text-left text-lg text-interface-neutral-6">
        {name}
      </p>
      <Avatar name={name} size="sm" />
    </button>
  );
};
